import { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Container, Link, Stack, Typography } from '@mui/material';

export default function TermsPage() {
  useEffect(() => {
    document.title = 'Terms of service — Baton';
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <Container maxWidth="md" sx={{ py: { xs: 6, md: 9 } }}>
      <Typography variant="h3" component="h1" sx={{ fontWeight: 800 }}>Terms of service</Typography>
      <Typography color="text.secondary" sx={{ mt: 0.5, fontStyle: 'italic' }}>
        Placeholder. Final terms will be published before launch.
      </Typography>
      <Stack spacing={2} sx={{ mt: 4 }}>
        <Typography>
          Baton is provided "as is" during private beta. Founding coaches receive lifetime free access
          to the early-access tier in exchange for feedback and reasonable forbearance on bugs.
        </Typography>
        <Typography>
          Contact: <Link component={RouterLink} to="/contact">Send us a message</Link>.
        </Typography>
      </Stack>
    </Container>
  );
}
